import { UAParser as uaParser } from 'ua-parser-js';
import { ErrorEvent } from '@sentry/react';
import { ENV } from '@user-portal/helpers';

import {
  ANDROID,
  ANDROID_MIN_VERSION,
  CHROME,
  CHROME_MIN_VERSION,
  HEIGHT_SIZE,
  IOS,
  IOS_MIN_VERSION,
  SENTRY_AXIOS,
  WIDTH_SIZE,
} from './consts';
import { ErrorType, TagsType, ExtrasType, IError } from './types';
import { objectEntriesPolyfill } from './utils';

export const getCustomTags = (_error: IError | unknown, type: ErrorType, extras?: ExtrasType): TagsType => {
  const customTags: Record<string, string> = {};

  if (type === SENTRY_AXIOS) {
    customTags.API_ERROR_CODE = extras?.status as string;
  }

  return objectEntriesPolyfill(customTags);
};

export const getTracesSampleRate = (env: string) => (env === ENV.prod ? 0.05 : 1);

export const checkFbBots = (windowWidth: number, windowHeight: number) =>
  windowWidth === WIDTH_SIZE && windowHeight === HEIGHT_SIZE;

export const checkIsOldDevices = (event: ErrorEvent) => {
  const UAParser = new uaParser();
  const getUserAgent = typeof event?.extra?.agent === 'string' ? event?.extra?.agent : '';
  const userAgent = UAParser.setUA(getUserAgent);

  const browser = userAgent && userAgent.getBrowser();
  const browserMajor = browser && browser.major;
  const browserName = browser && browser.name;

  const deviceOS = userAgent && userAgent.getOS();
  const deviceOSVersion = deviceOS && deviceOS.version;
  const deviceOSName = deviceOS && deviceOS.name;

  const parsedOSVersion = parseFloat(deviceOSVersion || '');
  const parsedBrowserVersion = parseFloat(browserMajor || '');

  return (
    (deviceOSName === IOS && parsedOSVersion < IOS_MIN_VERSION) ||
    (deviceOSName === ANDROID && parsedOSVersion < ANDROID_MIN_VERSION) ||
    (browserName === CHROME && parsedBrowserVersion < CHROME_MIN_VERSION)
  );
};
